<!-- FikoperasyonComponent - Dialog Core icinde render ediliyor -->
<div style="width:100%;min-width:300px;padding:8px;">
    <input class="fikoinput" type="text" #inputFikogram placeholder="Operasyon Ismi" [ngModel]="fikoperasyon?.name"
        (ngModelChange)="fikoperasyon.name=inputFikogram.value;this.FikoYT.degisti.emit();"
        style="margin-bottom:4px;font-size:12px;padding:5px;">

    <textarea class="fikoinputAciklama" #inputFikogramAciklama placeholder="Aciklama"
        [ngModel]="fikoperasyon?.userData?.aciklama"
        (ngModelChange)="fikoperasyon.userData.aciklama=inputFikogramAciklama.value;this.FikoYT.degisti.emit();"
        style="margin-bottom:6px;font-size:11px;padding:5px;resize:vertical;min-height:40px;max-height:70px;"></textarea>

    <div style="padding-top:6px;border-top:1px solid rgba(127,255,255,0.25);font-size:12px;">
        <div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;">
            <a class="ui circular icon label" (click)="tiklandi3DSec();" title="3D Dosya Ekle"
                style="background-color:transparent;box-shadow: 0px 0px 12px rgb(255 255 255 / 50%);cursor:pointer;">
                <img src="./simgeler/3d.webp"
                    style="width: 18px !important;height: 18px;object-fit: contain;">
            </a>

            <a class="ui circular icon label" title="3D Yazici"
                style="background-color:transparent;box-shadow: 0px 0px 12px rgb(255 255 255 / 50%);cursor:pointer;">
                <img src="./simgeler/3d-printer.webp"
                    style="width: 18px !important;height: 18px;object-fit: contain;">
            </a>

            <a class="ui circular icon label" (click)="tiklandiEksenSecimi();" title="Isleme Ekseni"
                style="background-color:transparent;box-shadow: 0px 0px 12px rgb(255 255 255 / 50%);cursor:pointer;">
                <img src="./simgeler/xyz-1.webp"
                    style="width: 18px !important;height: 18px;object-fit: contain;">
            </a>
        </div>
    </div>

    <!-- Kutuk Secimi -->
    <div style="padding-top:6px;border-top:1px solid rgba(127,255,255,0.25);font-size:12px;">
        <div style="margin-bottom:4px;font-weight:500;color:rgba(255,255,255,0.8);">Kutuk (Stock)</div>

        <!-- Secili kutuk bilgisi -->
        <div *ngIf="seciliKutuk" style="display:flex;gap:6px;align-items:center;margin-bottom:4px;">
            <div style="flex:1;padding:4px 6px;background:rgba(0,127,127,0.4);border-radius:3px;border:1px solid rgba(127,255,255,0.3);font-size:11px;color:#cff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                {{ seciliKutuk.name }}
                <span *ngIf="seciliKutuk.roughStockResult" style="color:#21ba45;margin-left:4px;">&#10003;</span>
                <span *ngIf="!seciliKutuk.roughStockResult" style="color:#f2711c;margin-left:4px;">&#9888; Stock yok</span>
            </div>
            <a class="ui circular icon label" (click)="tiklandiKutukDuzenle();" title="Kutuk Duzenle"
                style="background-color:transparent;box-shadow: 0px 0px 12px rgb(255 255 255 / 50%);cursor:pointer;">
                <img src="./simgeler/kupler.webp"
                    style="width: 18px !important;height: 18px;object-fit: contain;">
            </a>
            <a class="ui circular icon label" (click)="tiklandiKutukTemizle();" title="Secimi Kaldir"
                style="background-color:transparent;box-shadow: 0px 0px 12px rgb(255 100 100 / 50%);cursor:pointer;font-size:10px;">
                &#10005;
            </a>
        </div>

        <!-- Kutuk yoksa: mevcut kutukleri listele -->
        <div *ngIf="!seciliKutuk && mevcutKutukler.length > 0" style="margin-bottom:4px;">
            <div style="font-size:10px;color:rgba(255,255,255,0.6);margin-bottom:2px;">Mevcut kutukler:</div>
            <div *ngFor="let k of mevcutKutukler"
                (click)="tiklandiKutukSec(k)"
                style="padding:3px 6px;margin-bottom:2px;background:rgba(0,80,80,0.3);border-radius:3px;border:1px solid rgba(127,255,255,0.15);cursor:pointer;font-size:11px;color:#cff;"
                [style.border-color]="k.roughStockResult ? 'rgba(33,186,69,0.5)' : 'rgba(127,255,255,0.15)'">
                {{ k.name }}
                <span *ngIf="k.roughStockResult" style="color:#21ba45;font-size:9px;margin-left:4px;">stock mevcut</span>
            </div>
        </div>

        <!-- Hic kutuk yoksa bilgi mesaji -->
        <div *ngIf="!seciliKutuk && mevcutKutukler.length === 0"
            style="padding:4px;background:rgba(255,200,0,0.1);border-radius:3px;font-size:10px;color:rgba(255,255,255,0.5);">
            Kutuk bulunamadi. Once 3D dosya ekleyip kutuk olusturun.
        </div>
    </div>
</div>
